export const PERM_PER_FUNCTIONS = {
  "docu_sect.customize_docu": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "docu_sect.dl_electricalplan": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "docu_sect.dl_lxconfig": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "docu_sect.dl_pdf": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "docu_sect.dl_dxf": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_quote_elem": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_docu_elem": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_bom_elem": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_user_elem": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_settings_elem": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_floor_elem": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_room_elem": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.floor_editable_option": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.room_editable_option": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_clone_project": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_new_floor": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_dl_electrical_plan": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_dl_lxconfig": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "tree_sect.disp_dl_dxf": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.disp_color_change": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.customize_checkboxes": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.change_row_price_display": {
    "guest": true,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.curr_change": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.change_discount_n_tax": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.add_custom_product": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.add_custom_section": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.del_custom_product": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "quote_sect.dl_pdf": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "project_sect.edit_addr": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "project_sect.dl_electricalplan": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "project_sect.dl_lxconfig": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "project_sect.del_project": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": false,
    "project_owner": true
  },
  "users_sect.inv_user": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "users_sect.edit_user": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "settings_sect.edit_material": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "settings_sect.edit_electrical_plan": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "settings_sect.edit_wizard_products": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.show_mod_tools": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.show_visu_tools": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.show_prod_buttons": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.place_dev": {
    "guest": false,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.select_dev": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.place_note": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.delmod_note_other": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  },
  "planner_sect.delmod_note_own": {
    "guest": true,
    "designer": true,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "bom_sect.dl_csv": {
    "guest": false,
    "designer": false,
    "technician": true,
    "project_admin": true,
    "project_owner": true
  },
  "bom_sect.curr_change": {
    "guest": false,
    "designer": false,
    "technician": false,
    "project_admin": true,
    "project_owner": true
  }
};
